/**
 * Where a made bed's soft layers fall — fitted sheet, duvet, the sheet turned
 * back over it — as numbers, for the renderer that BUILDS the cloth
 * (`web-app/.../dormBedding/index.js`) and for anything seated ON it: the
 * staged bedroom stands shams in the head band and lays a throw on the duvet,
 * and its planner runs in the cloud function, so the numbers cannot live in
 * the web app.
 *
 * Metres. `headInset` is measured from the mattress's head edge.
 *
 * The one dress: full drape on every deck, loft and top bunk included. The
 * guardrail's underside sits 8.5" above the mattress and the duvet tops out at
 * 3.35", so the cloth passes well below it.
 */

const { SHEET_OVER_M, DUVET_THICKNESS_M } = require('./bedSurface');

const IN = 0.0254;

const BEDDING_LAYOUT = Object.freeze({
  sheetOver: SHEET_OVER_M, // fitted sheet above the mattress face
  duvetThickness: DUVET_THICKNESS_M,
  turnThickness: 0.55 * IN,
  turnDepth: 10 * IN,
  // Duvet's head edge, measured back from the head of the mattress.
  headInset: 18 * IN,
  ripple: 0.75 * IN, // undulation across the flat top
  gather: 0.7 * IN, // folds down the hanging skirt
  roll: 2.5 * IN, // inner roll radius at the mattress edge
  sideDrop: 7 * IN,
  footDrop: 6 * IN,
});

/**
 * The layout with a caller's overrides — the staged bedroom dresses a bed in
 * a loftier duvet than a dorm's. Pass the SAME overrides to
 * `buildBeddingSet` and to anything seated on the result, or the shams stand
 * on a duvet the cloth was not built at.
 */
const beddingLayout = (dress = {}) => ({ ...BEDDING_LAYOUT, ...dress });

/**
 * The documented outboard reach of the bedding past the mattress edge. The
 * duvet sits one thickness outboard, and the turned-down cuff one cuff
 * thickness outside the duvet's roll.
 */
const BEDDING_OVERHANG =
  BEDDING_LAYOUT.duvetThickness + BEDDING_LAYOUT.turnThickness;

module.exports = { BEDDING_LAYOUT, beddingLayout, BEDDING_OVERHANG };
